import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AppShell } from "@/components/layout/AppShell";
import Landing from "@/pages/Landing";
import Marketplace from "@/pages/Marketplace";
import AgentDetail from "@/pages/AgentDetail";
import Dashboard from "@/pages/Dashboard";
import MyAgents from "@/pages/MyAgents";
import NewAgent from "@/pages/NewAgent";
import Builder from "@/pages/Builder";
import Skills from "@/pages/Skills";
import Library from "@/pages/Library";
import ChatPage from "@/pages/ChatPage";
import Sales from "@/pages/Sales";
import Settings from "@/pages/Settings";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import ProductsCatalog from "@/pages/ProductsCatalog";
import ProductDetail from "@/pages/ProductDetail";
import AdminProducts from "@/pages/admin/AdminProducts";
import ProductEditor from "@/pages/admin/ProductEditor";
import AdminCenter from "@/pages/admin/AdminCenter";
import { useAuth } from "@/context/AuthContext";

const AdminOnly = ({ children }) => {
  const { user } = useAuth();
  return user?.is_admin ? children : <Navigate to="/dashboard" replace />;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  const guard = (el) => <ProtectedRoute>{el}</ProtectedRoute>;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/marketplace" element={<Marketplace />} />
      <Route path="/agent/:agentId" element={<AgentDetail />} />
      <Route path="/models" element={<ProductsCatalog key="model" kind="model" />} />
      <Route path="/software" element={<ProductsCatalog key="software" kind="software" />} />
      <Route path="/product/:productId" element={<ProductDetail />} />
      <Route path="/payment/success" element={guard(<PaymentSuccess />)} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/agents/:agentId/edit" element={guard(<Builder />)} />
      <Route path="/chat/:agentId" element={guard(<ChatPage />)} />
      <Route element={guard(<AppShell />)}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/agents" element={<MyAgents />} />
        <Route path="/agents/new" element={<NewAgent />} />
        <Route path="/skills" element={<Skills />} />
        <Route path="/library" element={<Library />} />
        <Route path="/sales" element={<Sales />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/admin/products" element={<AdminOnly><AdminProducts /></AdminOnly>} />
        <Route path="/admin/products/:productId" element={<AdminOnly><ProductEditor /></AdminOnly>} />
        <Route path="/admin/center" element={<AdminOnly><AdminCenter /></AdminOnly>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { borderRadius: 2, background: "#121212", border: "1px solid rgba(255,255,255,0.1)" } }} />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
